import axios from './axiosInstance'
import constants from '../constants'

/**
 * Associates a CLI auth session with the authenticated user.
 * @param {string} sessionId - 64-char hex session ID
 * @returns {Promise<{data?: object, error?: boolean, httpStatus?: number, errDescription?: string}>}
 */
export default async function associateCliAuthSession(sessionId) {
  const ccBearerToken = localStorage.getItem('ccBearerToken')
  if (!ccBearerToken) {
    return { error: true, httpStatus: 401, errDescription: 'No auth token' }
  }
  return axios
    .post(
      `${constants.customerDomain}cli-auth/session/associate`,
      { sessionId },
      { headers: { Authorization: `Bearer ${ccBearerToken}` } },
    )
    .then(res => res.data)
    .catch(error => {
      const status = error.response?.status
      const message =
        error.response?.data?.error?.message || 'Failed to associate CLI session'
      return { error: true, httpStatus: status, errDescription: message }
    })
}
